import { render, staticRenderFns } from "./fbUrl.vue?vue&type=template&id=28a87582&"
import script from "./fbUrl.vue?vue&type=script&lang=js&"
export * from "./fbUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports